import React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import { Modal } from 'react-bootstrap';

import HeatForecast from './HeatForecast';

@translate()
@inject('plantStore') @observer
export default class HeatForecastModal extends React.Component {
  render() {
    const {
      heatData, t, onDismiss, onSubmit, open, init,
    } = this.props;

    return (
      <Modal
        show={open}
        onHide={onDismiss}
        bsSize="large"
        backdrop="static"
      >
        <Modal.Header closeButton>Heat Forecast</Modal.Header>
        <Modal.Body>
          <HeatForecast
            heatData={heatData}
            init={init}
            onDismiss={onDismiss}
            onSubmit={onSubmit}
          />
        </Modal.Body>
      </Modal>

    );
  }
}
